import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { VolumeStack } from './VolumeStack';

/** TODO: replace with the live checkout URL (sales platform not defined yet). */
const CHECKOUT_URL = 'https://wrestling-practice-ready.impultienda.ar/checkout';
const included = ['6 volumes · 90 practices planned', '5 instant-use bonuses', '300 landscape pages, print or phone', '90, 75 and 60-minute clocks for every practice', '24 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-179" data-mp="25shl2uftn163">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-180" data-mp="20rjtxscu2wsg">
        <div className="text-center" data-id="element-181" data-mp="3h6v5fpbd8yhd">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-182" data-mp="3h5tk8s0myvlx">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-semibold text-plum text-3xl sm:text-5xl" data-id="element-183" data-mp="3vzgttth6raze">
            Everything you need to run the{' '}
            <span className="text-gold-deep" data-id="element-184" data-mp="4uyrmqgjrq5i">next 90 practices</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-185" data-mp="9qe8lr9uq265">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-186" data-mp="3d8z47xrngvi9">
            <h3 className="font-display text-xl font-semibold text-white sm:text-2xl" data-id="element-187" data-mp="3daijpm5hf2iz">
              Wrestling Practice Ready — The Complete Season Megapack
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-188" data-mp="3n6vfcpkl7qgd">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-189" data-mp="3rzy7qudmotuz">
            <div className="mx-auto max-w-lg rounded-2xl bg-plum-deep" data-id="element-190" data-mp="2uizhvin71uij">
              <VolumeStack data-id="element-191" data-mp="2ugn0b6lclm60" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-192" data-mp="2zgiwijnt09b0">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-193" data-mp="2rfjy1jrsyyp9">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-194" data-mp="2mibaf3nvy2gm">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-195" data-mp="315czvt257zgb" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-196" data-mp="23j5re82pxmyo">
              <div className="mt-1 flex items-start justify-center gap-1 text-plum" data-id="element-197" data-mp="23la85qlpuggd">
                <span className="mt-2.5 font-display text-3xl" data-id="element-198" data-mp="2ie3lp6hfgmie">$</span>
                <span className="font-display font-semibold text-6xl leading-[0.9] sm:text-7xl" data-id="element-199" data-mp="2dgahuk3lk4la">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-200" data-mp="3tx6exh6guevx">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-201" data-mp="9c7kfao8uy4">
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-202" data-mp="5971ystno2nx">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-203" data-mp="3rg595k9dmw36">
                  No subscription
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL} className="mt-5" data-id="element-204" data-mp="nyn1pdxinr3a">
                Get Wrestling Practice Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-muted" data-id="element-205" data-mp="a6qla757n5mq">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-206" data-mp="11zhahxoh7u2h">
                <li className="flex items-center gap-1.5" data-id="element-207" data-mp="16r95qlikunyy">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-208" data-mp="3f78u6j4glnht" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-209" data-mp="3592sa1inkhcy">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-210" data-mp="359mbrmnybdt3" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-211" data-mp="1rud5pfb7vlx">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-212" data-mp="3synbmlipxgmr" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-muted" data-id="element-213" data-mp="kj3n1zszsme1">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}